import Container from "../element/container";
import Image from "../element/image";
import {
  NoAccident,
  NoFire,
  NoFlood,
  NoTamping,
  ShieldTick,
  DCertified,
} from "../../assets/images";

export const INSPECTION_POINTS = 160;

const certificationList = [
  { image: NoAccident, label: "No Major Accidents" },
  { image: NoTamping, label: "No Tamping" },
  { image: NoFire, label: "No Fire" },
  { image: NoFlood, label: "No Flood" },
];

const gradeTone = (value) => {
  const grade = String(value || "").trim().toUpperCase();
  return grade === "S" ? "gold" : grade === "R" ? "red" : "blue";
};

// The certified card, condition score and grade tiles shared by the product
// modal summary and the full inspection report.
export default function CommonInspectionSummary({
  grade,
  grades = [],
  workshop,
  pointTotal,
  reference,
  passed = 0,
  identified = 0,
  focusGrade,
  onSelectGrade,
  onSelectTally,
  onOpenReport,
  t = (value) => value,
}) {
  const Tile = onOpenReport ? "div" : "button";
  const tileProps = onOpenReport ? {} : { type: "button" };
  return (
    <section className="inspection-summary">
      {String(grade || "").trim().toUpperCase() !== "R" && (
        <article className="inspection-summary-card">
          <img
            src={DCertified}
            className="_img certification-watermark"
            alt=""
            aria-hidden="true"
          />
          <header>
            <Image
              src={ShieldTick}
              alt={t("DCAR Certified")}
              className="_img inspection-summary-shield"
            />
            <Container tag="div">
              <h4>
                <strong>{t("DCAR")}</strong> {t("Certified")}
              </h4>
              <p>
                {t("We guarantee what matters most, transparent and worry-free")}
              </p>
            </Container>
          </header>
          <Container tag="div" className="inspection-summary-badges">
            {certificationList.map((item) => (
              <article key={item.label}>
                <Image
                  src={item.image}
                  alt={t(item.label)}
                  className="_img inspection-summary-badge"
                />
                <p>{t(item.label)}</p>
              </article>
            ))}
          </Container>
        </article>
      )}

      {/* The click opens the report, but the section itself is not a hover
          target - the tiles inside it own that, so there is no full-width
          overlay sitting on top of them. */}
      <div
        className="inspection-summary-details"
        {...(onOpenReport
          ? {
              role: "button",
              tabIndex: 0,
              "aria-label": t("Open inspection report"),
              onClick: onOpenReport,
              onKeyDown: (event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  onOpenReport();
                }
              },
            }
          : {})}
      >
      <Container tag="div" className="inspection-summary-score">
        <Container tag="div" className="inspection-summary-heading">
          <h4>{t("Condition Score")}</h4>
          <p>
            {t("Inspected by")} {workshop} - {pointTotal} {t("Spot")}
          </p>
          <p className="m-0">
            {t("Inspection ID")} {reference}
          </p>
        </Container>
        <Container tag="div" className="inspection-summary-grade" data-grade-tone={gradeTone(grade)}>
          <strong>{grade || "-"}</strong>
          <span>{t("CAR Grade")}</span>
        </Container>
      </Container>

      <Container tag="div" className="inspection-summary-grades">
        {grades.map((item) => (
          <Tile
            {...tileProps}
            className={`inspection-summary-tile ${
              focusGrade === item.key ? "active" : ""
            }`}
            data-grade-tone={gradeTone(item.value)}
            key={item.key}
            {...(!onOpenReport ? { disabled: !onSelectGrade } : {})}
            onClick={onOpenReport ? undefined : () => onSelectGrade?.(item.key)}
          >
            <strong>{item.value || "-"}</strong>
            <span>{t(item.label)}</span>
          </Tile>
        ))}
      </Container>

      <Container tag="div" className="inspection-summary-tally">
        <Tile
          {...tileProps}
          className="inspection-summary-count"
          {...(!onOpenReport ? { disabled: !onSelectTally } : {})}
          // onClick={() => onSelectTally?.("passed")}
        >
          <span>{t("Pass Checks")}</span>
          <strong className="pass">{passed}</strong>
        </Tile>
        <Tile
          {...tileProps}
          className="inspection-summary-count"
          {...(!onOpenReport ? { disabled: !onSelectTally } : {})}
          // onClick={() => onSelectTally?.("identified")}
        >
          <span>{t("Identified")}</span>
          <strong className="danger">{identified}</strong>
        </Tile>

      </Container>
      </div>
    </section>
  );
}
